module.exports = __webpack_public_path__ + "img/arrecredihome2v_1n.5635539e.webp";